// 소수점 => 일, 시간 포맷으로 변환
export const formatLeave = (days) => {
  if (days === null) return '-'

  const day = Math.floor(days)
  const hour = Math.round((days - day) * 8)

  if (day > 0 && hour > 0) return `${day}일 ${hour}시간`
  if (day > 0) return `${day}일`
  return `${hour}시간`
}

// 총 개월 수 => 년, 개월 포맷으로 변환
export const returnMonthToYear = (month) => {
  // 12개월 미만일 때 (0~11개월)
  if (month < 12) {
    return `${month}개월`
  }

  const years = Math.floor(month / 12)
  const remainingMonths = month % 12

  // 12, 24, 36개월 등 딱 떨어지는 경우
  if (remainingMonths === 0) {
    return `${years}년 차`
  }

  // 그 외 (예: 1년 3개월 차)
  return `${years}년 ${remainingMonths}개월`
}
